import React from "react";

import AccessContextProvider from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanTab/ModelDrawer/ModelDrawerAccess/AccessContextProvider";
import AccessTabWithBaseDrawer from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanTab/ModelDrawer/ModelDrawerAccess/AccessTabWithBaseDrawer";

const AccessTab: React.FC = () => {
  return (
    <AccessContextProvider>
      <AccessTabWithBaseDrawer />
    </AccessContextProvider>
  );
};

export default AccessTab;
